import React, { useState, Component } from "react";
import { Container, Row, Col, Tab, Nav, Modal, Form, ToggleButton, ToggleButtonGroup, InputGroup, Dropdown, DropdownButton } from 'react-bootstrap';
import { apiCall } from './../../helpers/api'
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import AlertModal from "../../components/alerts/alert";
import { datePickerToEpoch, getDifference } from "../../helpers/dates";
import { getSmallNumber } from "../../helpers/stats";
import { ImageUploadPreviewComponent } from "../../components/images/ImageUpload";
import { getImageUrl } from "../../helpers/images";
import { useImageContext } from "../../hooks/useImageContext";
import { GenerativeInput } from "../../components/inputs/generativeInput/GenerativeInput";
import { offeringPrompt, lookingForPrompt } from "../../components/inputs/generativeInput/Prompts"

import FullPageSpinner from "../../components/spinner/FullPageSpinner";
import './Campaigns.css';
import NoAccess from "../../images/no-access.png";
import Topbar from "../../components/topbar/Topbar";
import Footer from "../../components/footer/Footer";
import Details from './../../images/brand-details-blue.svg';
import { useAuthContext } from "../../hooks/useAuthContext";
import backArrow from './../../images/back-arrow-blue.svg';



export function CreateCampaignFunction(props) {
    const [showAlert, setAlert] = useState({"display":"toast","visible":false,"title":"","content":""});
    const hideAlert = () => setAlert({"display":"toast","visible":false,"title":"","content":""});
    const { providers } = useImageContext();

    const [signupData, setSignupData] = useState({
        "territories": ["all"], //sets to all so all campaigns can be seen by the members since we have removed territories from create campaign 
        "deliveryAddress" : false,
        "usageRights" : false,
        "email" : false,
        "phoneNumber" : false,
        "ages" : ["Any"],
        "influencerSegments" : ["Any"],
        "tips" : ["Create and share your content on time", "Use the correct tags in all content produced", "Be creative, stay true to yourself & have fun!"],
        "images": [],
        "categories": [],
        "name":"",
        "offeringType": "", // product, experience, or service
        "minimumBudget":0,
        "currency":"GBP",
        "offering":"",
    }); 

    var brand = null
    var campaign = null
    var cloneCampaign = null
    const [ranOnce, setRanOnce] = useState(false)
    const [ranOnceBrand, setRanOnceBrand] = useState(false)
    const [addTermsAndConditions, setTermsAndConditions] = useState(false);
    const [imagesChanged, setImagesChanged] = useState(false);
    const navigate = useNavigate()

    const [categories, setCategories] = useState(() => []);
    const [categoriesValidationError,setCategoriesValidationError] = useState(null);
    const updateCategories = (newValue) => {
        if (newValue.length > 3){
            setCategoriesValidationError("Cannot have more than three categories selected. Please unselect one to choose another.")
        }
        else{
            setCategories(newValue);
            updateSignupDataState(newValue,"categories");
            setCategoriesValidationError(null)
        }
    };

    const [loadingImages, setLoadingImages] = useState(false);

    const [ages, setAges] = useState(() => []);
    const updateAges = (newValue) => {
        if (newValue.slice(-1) == "Any"){
            newValue = ["Any"]
        }
        else if (newValue.includes("Any")){
            newValue = newValue.filter(function(age) { return age !== 'Any' });
        }
        setAges(newValue);
        updateSignupDataState(newValue,"ages");
    };

    const [influencerSegments, setInfluencerSegments] = useState(() => []);
    const updateInfluencerSegments = (newValue) => {
        if (newValue.slice(-1) == "Any"){
            newValue = ["Any"]
        }
        else if (newValue.includes("Any")){
            newValue = newValue.filter(function(segments) { return segments !== 'Any' });
        }
        setInfluencerSegments(newValue);
        updateSignupDataState(newValue,"influencerSegments");
    };

    
    const [campaignType, setCampaignType] = useState(null)
    const [campaignBudget, setCampaignBudget] = useState(true)

    const [territories, setTerritories] = useState(() => []);
    const updateTerritories = (newValue) => {
        setTerritories(newValue);
        updateSignupDataState(newValue,"territories");
    };
    // Note: "territories" is intentionally not included in requiredFields.
    // It is an optional field in the campaign payload and defaults to ["all"]
    // (and is validated) outside this component, so client-side validation
    // does not require it to be set explicitly.
    const requiredFields = ["name","categories","offering","startDate","endDate","ages","influencerSegments"];
    const [nameCount, setNameCount] = React.useState(0);
    const [offeringCount, setOfferingCount] = React.useState(0);
    const [images,setImages] = useState([])
    const [showOfferingToolTip, toggleOfferingToolTip] = useState(false)  
    const [tips, setTips] = useState(["Create and share your content on time", "Use the correct tags in all content produced", "Be creative, stay true to yourself & have fun!"])
    const updateTips = (tip,position) => {
        var tempTips = tips;
        while (tempTips.length < position + 1){
            tempTips.push("")
        }
        tempTips[position] = tip
        setTips(tempTips)
        updateSignupDataState(tempTips,"tips")
    }

    const [tipsCount, setTipsCount] = React.useState([37,44,36,0]);
    const updateTipsCount = (length,position) => {
        var tempTipsCount = tipsCount;
        while (tempTipsCount.length < position + 1){
            tempTipsCount.push("")
        }
        tempTipsCount[position] = length;
        setTipsCount(tempTipsCount)
    }

    if (props.hasOwnProperty("brand")) {
        brand = props.brand
        if (!props.campaign && brand && brand.hasOwnProperty("terms")) {
            if (!ranOnceBrand) {
                setRanOnceBrand(true)
                setTermsAndConditions(props.brand.terms.length > 0);
            }
        }
    }

    if (props.hasOwnProperty("campaign")){
        campaign = props.campaign
        cloneCampaign = props.cloneCampaign
        // This is a bit of a quick and dirty way to get around the fact that we need to re-render certain things
        // but can't set campaign data each time. I'm sure I've missed something and we can just do this a nicer
        // way but at least it works :D
        if (!ranOnce){
            setLoadingImages(true)
            setRanOnce(true)
            setSignupData({
                "name": props.campaign.name,
                "territories": props.campaign.territories,
                "deliveryAddress" : props.campaign.requirements.deliveryAddress,
                "usageRights" : props.campaign.requirements.usageRights,
                "email" : props.campaign.requirements.email,
                "phoneNumber" : props.campaign.requirements.phoneNumber,
                "ages" : props.campaign.criteria.ages,
                "influencerSegments" : props.campaign.criteria.influencerSegments,
                "tips" : props.campaign.tips,
                "categories" : props.campaign.categories,
                "offering" : props.campaign.offering,
                "images" : props.campaign.images,
                "startDate" : props.campaign.startDate,
                "endDate" : props.campaign.endDate,
                "terms" : props.campaign.terms,
                "campaignType" : props.campaign.campaignType,
                "currency" : props.campaign.budget.currency,
                "minimumBudget" : props.campaign.budget.minimum
            })
            setNameCount(props.campaign.name.length)
            setOfferingCount(props.campaign.offering.length)
            setTermsAndConditions(props.campaign.terms.length > 0);
            setTips(props.campaign.tips);
            setCampaignType(props.campaign.campaignType);
            loadExistingImages(props.campaign.images);
            setCampaignBudget(props.campaign.hasBudget)
        
            if (props.cloneCampaign) {
                props.campaign.active = false
                props.campaign.archived = false
            }
        }
    }

    async function loadExistingImages(images){
        var newImages = [];
        for (const image of images){
            const file = {"url":getImageUrl(providers,image),"data":image.id,"new":false,"original":image}
            //const file = await getImageFromUrl(getImageUrl(providers,image),image.id)
            newImages.push(file);
        }
        setImages(newImages);
        setLoadingImages(false)
    }

    async function uploadNewImages(images){
        var failedImages = [];
        var campaignImages = [];
        for (const image of images){
            if (image.new) {
                const formData = new FormData();
                formData.append("file",image.data)
                formData.append("public_id",image.metadata.public_id)
                formData.append("api_key",image.metadata.api_key)
                formData.append("timestamp",image.metadata.timestamp)
                formData.append("signature",image.metadata.signature)
                if (image.metadata.folder != ""){
                    formData.append("folder",image.metadata.folder)
                }
                campaignImages.push(await fetch(`${image.metadata.target}/${image.metadata.resource_type}/upload`, {
                    method: "POST",
                    body: formData
                }).then(async response => {
                    try {
                        let responseJSON = await response.json();
                        if (response.ok) {
                            return {"id":responseJSON.public_id,"source":image.metadata.source,"name":image.data.name}
                            }
                        else {
                            failedImages.push(image)
                        }
                    } catch (error) {
                        failedImages.push(image)
                    }
                }))
            }
            else {
                campaignImages.push(image.original)
            }
        }
        return campaignImages;
      }

    async function saveCampaign(event,action="draft") {
        // Validate data
        var valid = true;
        var validityIssues = [];
        if (addTermsAndConditions && (!("terms" in signupData) || signupData["terms"].length == 0)){
            validityIssues.push("Terms have not been defined")
            valid = false;
        }
        if (datePickerToEpoch(signupData.startDate) > datePickerToEpoch(signupData.endDate)){
            validityIssues.push("End date cannot be after start date")
            valid = false;
        }
    
        if ( action == "publish" || (campaign && campaign.active) ){
            requiredFields.forEach(field => {
                if (!(field in signupData)){
                    validityIssues.push(`${field} is missing`)
                    valid = false;
                }
                else if (signupData[field].length == 0){
                    validityIssues.push(`${field} is missing`)
                    valid = false;
                }
            });
            if (images.length == 0){
                validityIssues.push("No images chosen")
                valid = false;
            }
            if (signupData.hasOwnProperty("endDate") && !getDifference(datePickerToEpoch(signupData.endDate)).future){
                validityIssues.push("End date cannot be in the past!")
                valid = false;
            }
        }
        if (!valid){
            setAlert({"display":"toast","visible":true,"title":"Form Issues","content":"Outstanding issues: " + validityIssues.join(", "),"className":"bg-danger text-background"})
        }
        if ((action != "publish" && (!campaign || (campaign && !campaign.active))) && signupData.name.length == 0){
            setAlert({"display":"toast","visible":true,"title":"Cannot Save Draft","content":"Please specify a title to save this Listing as a draft","className":"bg-danger text-background"})
            valid = false;
        }
        if (valid){
            signupData.hasBudget = true;
            signupData.tips = tips.filter(function(tip) {return tip.length > 0});
            if (!addTermsAndConditions) {
                signupData.terms = ""
            }
            if (!campaign || (campaign && !campaign.active)) {
                if (signupData.startDate) {
                    signupData.startDate = datePickerToEpoch(signupData.startDate)
                    signupData.endDate = datePickerToEpoch(signupData.endDate)
                }
                else {
                    signupData.startDate = 0
                    signupData.endDate = 0
                }
                // Upload images first
                if (images.length > 0){
                    signupData.images = await uploadNewImages(images) 
                }
                else {
                    signupData.images = []
                }
            }
            else {
                signupData.startDate = datePickerToEpoch(signupData.startDate)
                signupData.endDate = datePickerToEpoch(signupData.endDate) 
                // Upload images first
                signupData.images = await uploadNewImages(images) 
            }
            if (action == "publish"){
                var response = await apiCall('campaign/publish',{ "method" : "PUT", "data" : {"id":campaign._id} });
                if (response["success"]){
                    return navigate("/Campaigns")
                }
                else if (response["failure"]){
                    setAlert({"display":"toast","visible":true,"title":"Error Publishing Listing","content":response["failure"]["error"],"className":"bg-danger text-background"})
                  }
            }
            if (action == "draft" || (action == "preview" && (!campaign || cloneCampaign))){
                if (signupData.images.length > 0 || action == "draft"){
                    var response = await apiCall('campaign',{ "method" : "POST", "data" : signupData });
                    if (response["success"]){
                        if (action == "draft"){
                            setAlert({"display":"toast","visible":true,"title":"Listing Draft Saved","content":"Listing Saved as Draft","className":"bg-success text-background"})
                            window.location.href=`/Campaign/Create?id=${response["success"]["campaign_id"]}`;
                        }
                        else {
                            return navigate(`/Campaign/Preview?id=${response["success"]["campaign_id"]}`)
                        }
                    }
                    else {
                        setAlert({"display":"toast","visible":true,"title":"Unable to Create Listing","content":response["failure"]["error"],"className":"bg-danger text-background"})
                    }
                }
                else {
                    setAlert({"display":"toast","visible":true,"title":"Unable to Create Listing","content":"Could not upload images","className":"bg-danger text-background"})
                }
            }
            if (action == "update" || (action == "preview" && campaign && !cloneCampaign)){
                signupData["id"] = campaign._id
                var response = await apiCall(`campaign`,{ "method" : "PUT", "data" : signupData });
                if (response["success"]){
                    if (action == "update"){
                        setAlert({"display":"toast","visible":true,"title":"Listing Saved","content":"Listing Updated","className":"bg-success text-background"})
                    }
                    else {
                        return navigate(`/Campaign/Preview?id=${campaign._id}`)
                    }
                }
                else {
                    setAlert({"display":"toast","visible":true,"title":"Unable to Update Listing","content":response["failure"]["error"],"className":"bg-danger text-background"})
                }
            }
        }
        event.preventDefault();
    }

    function updateSignupDataState(props, id=null) {
        var tempUserData = Object.assign({},signupData);
        if (id != null){
            tempUserData[id] = props
        }
        else if ( props.target.type == "checkbox" ) {
            tempUserData[props.target.id] = props.target.checked;
        } 
        else {
            tempUserData[props.target.id] = props.target.value;
        }
        setSignupData(tempUserData);
    }



    function ToggleButtonGroupCategories() {    
        return (
            <>
            {categoriesValidationError ? (<span className="small text-muted d-block mb-3"><b className="text-danger">{categoriesValidationError}</b></span>) : null}
            <ToggleButtonGroup type="checkbox" value={campaign && categories.length == 0 ? campaign.categories : categories} onChange={updateCategories} id="categories">
                <ToggleButton id="tbg-btn-1" className="me-2 mb-2" value="Activities">Activities</ToggleButton>
                <ToggleButton id="tbg-btn-2" className="me-2 mb-2" value="Arts & Culture">Arts & Culture</ToggleButton>
                <ToggleButton id="tbg-btn-3" className="me-2 mb-2" value="Automotive">Automotive</ToggleButton>
                <ToggleButton id="tbg-btn-4" className="me-2 mb-2" value="Beauty, Grooming & Fragrance">Beauty, Grooming & Fragrance</ToggleButton>
                <ToggleButton id="tbg-btn-5" className="me-2 mb-2" value="Books & Magazines">Books & Magazines</ToggleButton>
                <ToggleButton id="tbg-btn-6" className="me-2 mb-2" value="Charity & Nonprofit">Charity & Nonprofit</ToggleButton>
                <ToggleButton id="tbg-btn-7" className="me-2 mb-2" value="Children & Baby">Children & Baby</ToggleButton>
                <ToggleButton id="tbg-btn-8" className="me-2 mb-2" value="Entertainment & Media">Entertainment & Media</ToggleButton>
                <ToggleButton id="tbg-btn-9" className="me-2 mb-2" value="Environment">Environment</ToggleButton>
                <ToggleButton id="tbg-btn-10" className="me-2 mb-2" value="Fashion">Fashion</ToggleButton>
                <ToggleButton id="tbg-btn-11" className="me-2 mb-2" value="Food & Drink">Food & Drink</ToggleButton>
                <ToggleButton id="tbg-btn-12" className="me-2 mb-2" value="Health, Wellness & Personal Care">Health, Wellness & Personal Care</ToggleButton>
                <ToggleButton id="tbg-btn-13" className="me-2 mb-2" value="Holidays & Travel">Holidays & Travel</ToggleButton>
                <ToggleButton id="tbg-btn-14" className="me-2 mb-2" value="Home & Garden">Home & Garden</ToggleButton>
                <ToggleButton id="tbg-btn-15" className="me-2 mb-2" value="Lifestyle">Lifestyle</ToggleButton>
                <ToggleButton id="tbg-btn-16" className="me-2 mb-2" value="Pets">Pets</ToggleButton>
                <ToggleButton id="tbg-btn-17" className="me-2 mb-2" value="Restaurants, Bars & Clubs">Restaurants, Bars & Clubs</ToggleButton>
                <ToggleButton id="tbg-btn-18" className="me-2 mb-2" value="Sport & Fitness">Sport & Fitness</ToggleButton>
                <ToggleButton id="tbg-btn-19" className="me-2 mb-2" value="Technology, Gaming & Electronics">Technology, Gaming & Electronics</ToggleButton>
                <ToggleButton id="tbg-btn-20" className="me-2 mb-2" value="Tickets">Tickets</ToggleButton>
            </ToggleButtonGroup>
            </>
        );
    }

    function ToggleButtonAgeRange() {      
        return (
          <ToggleButtonGroup type="checkbox" value={campaign && ages.length == 0 ? campaign.criteria.ages : ages} onChange={updateAges} id="age">
            <ToggleButton id="ageRange-1" className="me-2 mb-2" value="Any">Any</ToggleButton>
            <ToggleButton id="ageRange-2" className="me-2 mb-2" value="18 - 24">18 - 24</ToggleButton>
            <ToggleButton id="ageRange-3" className="me-2 mb-2" value="25 - 34">25 - 34</ToggleButton>
            <ToggleButton id="ageRange-4" className="me-2 mb-2" value="35 - 44">35 - 44</ToggleButton>
            <ToggleButton id="ageRange-5" className="me-2 mb-2" value="45 - 59">45 - 59</ToggleButton>
            <ToggleButton id="ageRange-6" className="me-2 mb-2" value="60+">60+</ToggleButton>
          </ToggleButtonGroup>
        );
    }

    function ToggleButtonInfluencerSegments() {      
        return (
          <ToggleButtonGroup type="checkbox" value={campaign && influencerSegments.length == 0 ? campaign.criteria.influencerSegments : influencerSegments} onChange={updateInfluencerSegments} id="influencerSegments">
            <ToggleButton key={"Any"} id={`tbg-btn-Any`} className="me-2 mb-2" value={"Any"}>Any</ToggleButton>
            <ToggleButton key={"Digital First"} id={`tbg-btn-Digital-First`} className="me-2 mb-2" value={"Digital First"}>Digital First</ToggleButton>
            <ToggleButton key={"Talent First"} id={`tbg-btn-Talent-First`} className="me-2 mb-2" value={"Talent First"}>Talent First</ToggleButton>
            <ToggleButton key={"Creator"} id={`tbg-btn-Creator`} className="me-2 mb-2" value={"Creator"}>Creator</ToggleButton>
            <ToggleButton key={"Consumer"} id={`tbg-btn-Consumer`} className="me-2 mb-2" value={"Consumer"}>Consumer</ToggleButton>
          </ToggleButtonGroup>
        );
    }

    function ToggleButtonTerritories() {      
        return (
          <ToggleButtonGroup type="checkbox" value={campaign && territories.length == 0 ? campaign.territories : territories} onChange={updateTerritories} id="territories">
            <ToggleButton id="territories-1" className="me-2 mb-2" value="GB">UK</ToggleButton>
            <ToggleButton id="territories-2" className="me-2 mb-2" value="IE">Ireland</ToggleButton>
            <ToggleButton id="territories-3" className="me-2 mb-2" value="US">USA</ToggleButton>
            <ToggleButton id="territories-4" className="me-2 mb-2" value="DE">Germany</ToggleButton>
          </ToggleButtonGroup>
        );
    }

    let [searchParams] = useSearchParams();
    var view = searchParams.get('view');
    if (view == null){
        view = "details";
    }
    const [tabID, setTabID] = useState(view);



if (!campaignType) {
    return (
        <div className="bg-page campaignPage mt-md-3 pt-md-0 mt-lg-4 pt-lg-0 mt-xl-0 pt-xl-4 px-md-5">
            <Container fluid className="align-items-center">
                <Row className="d-flex align-items-stretch justify-content-center">
                    <Col xs="12">
                        <h3 className="text-center mb-md-4 pt-md-4 pb-4 pt-5 mt-3 fw-normal">Create Listing</h3>
                    </Col>
                    
                    {/* Product Listing */}
                    <Col xs={12} md={6} lg={4} className="text-center mb-4">
                        <div onClick={e => {updateSignupDataState("product","campaignType"); setCampaignType("product");}} className="rounded-xl border bg-background p-3 shadow hover h-100">
                            <img src="https://res.cloudinary.com/theroomio/image/upload/v1747213640/V3/influencer_marketing_ymyqol.webp" height="500px" className="rounded border w-100 object-fit-cover" />
                            <button className="btn btn-primary rounded-bottom my-3 w-100">Sell</button>
                            <div className="mx-4 text-muted">List items for our members to buy</div>
                        </div>
                    </Col>
                    
                    {/* Experience Campaign */}
                    <Col xs={12} md={6} lg={4} className="text-center mb-4">
                        <div onClick={e => {updateSignupDataState("experience","campaignType"); setCampaignType("experience");}} className="rounded-xl border bg-background p-3 shadow hover h-100">
                            <img src="https://res.cloudinary.com/theroomio/image/upload/v1747213640/V3/influencer_marketing_ymyqol.webp" height="500px" className="rounded border w-100 object-fit-cover" />
                            <button className="btn btn-primary rounded-bottom my-3 w-100">Experiences</button>
                            <div className="mx-4 text-muted">List events for our members to attend</div>
                        </div>
                    </Col>
                    
                    {/* Service Campaign */}
                    <Col xs={12} md={6} lg={4} className="text-center mb-4">
                        <div onClick={e => {updateSignupDataState("service","campaignType"); setCampaignType("service");}} className="rounded-xl border bg-background p-3 shadow hover h-100">
                            <img src="https://res.cloudinary.com/theroomio/image/upload/v1747213640/V3/influencer_marketing_ymyqol.webp" height="500px" className="rounded border w-100 object-fit-cover" />
                            <button className="btn btn-primary rounded-bottom my-3 w-100">Service</button>
                            <div className="mx-4 text-muted">List services for our members to use</div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}
    
    return (
        <>
        <AlertModal modal={showAlert} onClose={hideAlert} />
        <Tab.Container activeKey={tabID} onSelect={(key) => setTabID(key)}>
            <Container>
                <Row className="d-flex justify-content-center">
                    <Col sm={12} md={4} lg={4} xl={4} xxl={3}>

                        <div className="d-flex align-items-center justify-content-between mt-4 mb-4 pb-2 pt-4">
                            <h1 className="pageTitle text-navy fw-700 d-flex align-items-center gap-2" id="details">
                                {campaign && !cloneCampaign ? "Update Listing" : "Create Listing"}
                                {!campaign && (
                                    <button
                                        type="button"
                                        onClick={e => {updateSignupDataState(null,"campaignType"); setCampaignType(null)}}
                                        className="btn btn-link p-0 ms-3 text-primary"
                                    >
                                        Change Type
                                    </button>
                                )}
                            </h1>
                        </div>

                        <Nav variant="tabs" className="border-0 mb-4">
                            <div className="bg-background rounded-xl createCampaignNav w-100 shadow">
                                <Nav.Link eventKey="details" className="p-3 d-flex align-items-center justify-content-between w-100">
                                    <div className="d-flex align-items-center">
                                        <Nav.Item className="d-flex align-items-center">
                                            <img src={Details} className="me-3 d-none d-md-block" /> <span>Details</span>
                                        </Nav.Item>
                                    </div>
                                    <span className="d-none d-md-block">
                                        <svg width="10" height="14" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M0.202121 11.0106C0.351235 11.1566 0.553783 11.2305 0.756918 11.2304C0.941136 11.2304 1.12582 11.1697 1.27148 11.0469L7.11501 6.11921C7.26929 5.98911 7.35699 5.80648 7.35699 5.61522C7.35699 5.42396 7.26929 5.24133 7.11501 5.11122L1.27148 0.183585C0.965268 -0.0746763 0.486351 -0.0585183 0.202078 0.219836C-0.0822364 0.49819 -0.0643693 0.933236 0.241974 1.19154L5.48786 5.61522L0.242016 10.0389C-0.0643276 10.2972 -0.0821941 10.7322 0.202121 11.0106Z" stroke="none" fill="#A7A7A7"/>
                                        </svg>
                                    </span>
                                </Nav.Link>
                                <Nav.Link eventKey="offering" className="p-3 d-flex align-items-center justify-content-between w-100">
                                    <div className="d-flex align-items-center">
                                        <Nav.Item className="d-flex align-items-center">
                                            <img src={Details} className="me-3 d-none d-md-block" /> <span>Offering</span>
                                        </Nav.Item>
                                    </div>
                                    <span className="d-none d-md-block">
                                        <svg width="10" height="14" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M0.202121 11.0106C0.351235 11.1566 0.553783 11.2305 0.756918 11.2304C0.941136 11.2304 1.12582 11.1697 1.27148 11.0469L7.11501 6.11921C7.26929 5.98911 7.35699 5.80648 7.35699 5.61522C7.35699 5.42396 7.26929 5.24133 7.11501 5.11122L1.27148 0.183585C0.965268 -0.0746763 0.486351 -0.0585183 0.202078 0.219836C-0.0822364 0.49819 -0.0643693 0.933236 0.241974 1.19154L5.48786 5.61522L0.242016 10.0389C-0.0643276 10.2972 -0.0821941 10.7322 0.202121 11.0106Z" stroke="none" fill="#A7A7A7"/>
                                        </svg>
                                    </span>
                                </Nav.Link>

                                {/* <Nav.Link eventKey="customisation" className="p-3 d-flex align-items-center justify-content-between w-100">
                                    <div className="d-flex align-items-center">
                                        <Nav.Item className="d-flex align-items-center">
                                            <img src={Details} className="me-3 d-none d-md-block" /> <span>Customisation</span>
                                        </Nav.Item>
                                    </div>
                                    <span className="d-none d-md-block">
                                        <svg width="10" height="14" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M0.202121 11.0106C0.351235 11.1566 0.553783 11.2305 0.756918 11.2304C0.941136 11.2304 1.12582 11.1697 1.27148 11.0469L7.11501 6.11921C7.26929 5.98911 7.35699 5.80648 7.35699 5.61522C7.35699 5.42396 7.26929 5.24133 7.11501 5.11122L1.27148 0.183585C0.965268 -0.0746763 0.486351 -0.0585183 0.202078 0.219836C-0.0822364 0.49819 -0.0643693 0.933236 0.241974 1.19154L5.48786 5.61522L0.242016 10.0389C-0.0643276 10.2972 -0.0821941 10.7322 0.202121 11.0106Z" stroke="none" fill="#A7A7A7"/>
                                        </svg>
                                    </span>
                                </Nav.Link> */}
                            </div>
                        </Nav>

                        <Row>
                            {campaign && !cloneCampaign ? (
                                <>
                                {!campaign.active && <Col sm={12}><button className="btn btn-primary w-100 mb-3" onClick={(event) => {saveCampaign(event,"publish")}}>Publish</button></Col>}
                                <Col xs={6} sm={6} md={12} lg={6} xl={6} className="mb-3"><button className="btn btn-outline-primary success w-100 mb-3" onClick={(event) => {saveCampaign(event,"update")}}>Update</button></Col>
                                <Col xs={6} sm={6} md={12} lg={6} xl={6} className="mb-3"><button className="btn btn-primary w-100" onClick={(event) => {saveCampaign(event,"preview")}}>Save & Preview</button></Col>
                                </>
                            ) : (
                                <>
                                <Col xs={6} sm={6} md={12} lg={6} xl={6} className="mb-3"><button className="btn btn-outline-primary w-100" onClick={(event) => {saveCampaign(event,"draft")}}>Save as Draft</button></Col>
                                <Col xs={6} sm={6} md={12} lg={6} xl={6} className="mb-3"><button className="btn btn-primary w-100" onClick={(event) => {saveCampaign(event,"preview")}}>Save & Preview</button></Col>
                                </>
                            )}
                            <Col sm={12} className="mb-3"><Link to="/Campaigns" className="btn btn-outline-danger w-100">Discard Changes</Link></Col>
                        </Row>
                    </Col>
                    <Col sm={12} md={8} lg={8} xl={8} xxl={7}>
                        <Tab.Content>
                            <Tab.Pane eventKey="details">
                                <div className="px-lg-4 pt-md-4 mt-4 px-md-0">
                                    <div className="p-4 bg-background shadow rounded-xl">
                                        <div className="d-flex align-items-center justify-content-between mb-4">
                                            <h5 className="mb-0">Details</h5>
                                            <div>
                                                <button disabled={!signupData.name || !images.length || !signupData.categories.length} onClick={() => {setTabID("offering")}} className="btn btn-sm btn-primary">Next</button>
                                            </div>
                                        </div>

                                        <div className="createCampaignForm">
                                            <div className="form-group my-4 position-relative">
                                                <label>Title</label>
                                                <input type="text" id="name" maxLength="50" className="form-control pe-5" onChange={e => {updateSignupDataState(e);  setNameCount(e.target.value.length)}} defaultValue={campaign ? campaign.name : null}/>
                                                <span className="position-absolute smaller end-0 top-0 text-muted mt-4 pt-3 me-2">{nameCount}/50</span>
                                            </div>

                                            <hr className="my-4" />

                                            <div className="form-group mb-4">
                                                <label>Images (up to 5)</label>
                                                <span className="small text-muted d-block">Capture interest with great quality images that show off what you’re offering!  For example: product photos, publicity shots, previous events etc.</span>
                                                {loadingImages ? <p>Loading Images...</p> : 
                                                    <ImageUploadPreviewComponent images={images} setImages={setImages} setImagesChanged={setImagesChanged}/>
                                                }
                                                <span className="small text-muted d-block">Please only upload the following formats: <b>PNG</b>, <b>JPEG/JPG</b>, <b>WEBP</b> & <b>HEIC</b>.</span>
                                                <span className="small text-muted d-block"><i>Images should be of high enough quality (500x500 pixels minimum) but no larger than 5mb in size.</i></span>
                                            </div>

                                            <hr className="my-4" />

                                            <div className="form-group">
                                                <label>Categories:</label>
                                                <span className="small text-muted d-block mb-3">Please select up to 3 categories for your listing</span>                

                                                <ToggleButtonGroupCategories />
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </Tab.Pane>

                            <Tab.Pane eventKey="offering">
                                <Modal centered show={showOfferingToolTip} onHide={() => toggleOfferingToolTip(false)}>
                                    <Modal.Footer className="border-0 rounded success">
                                        <Form className='justify-content-between align-items-center w-100 m-0'>
                                            {!campaignBudget && (
                                                <>
                                                    <p className='m-0 ps-2'>Include details about what you're offering in exchange for content. This might be a product, an experience or listing involvement. Tell bidders what makes it special and why they'll love it.</p>
                                                    <br />
                                                    <p className='m-0 ps-2'>* Add information about your brand; your values, beliefs and what you stand for - people will bid for love not money when they get what you're all about.</p>
                                                    <p className='m-0 ps-2'>* Explain the product, service or experience that you are offering </p>
                                                    <p className='m-0 ps-2'>* The more you give, the more you get so be generous in the amount or the value of your offer</p>
                                                    <p className='m-0 ps-2'>* Bullet points work well for the offer so you can cover off key points</p>
                                                    <br />
                                                    <h3 className="font-bold">Example description:</h3>
                                                    <br />
                                                    <p className='m-0 ps-2'>DABOO are passionate about engaging young minds and are on a mission to help children thrive as they learn about the world around them. Daboo offers a range of natural world topic, fully sustainable children’s books which are packaged in proven formats to engage in age specific ways. We’re offering:</p>
                                                    <br />
                                                    <p className='m-0 ps-2'>- A box of 10 x pop up books, audio recordings and video games for Elementary aged children</p>
                                                </>
                                            )}
                                            {campaignBudget && (
                                                <>
                                                    <p className='m-0 ps-2'>Include details about what you’re offering in exchange for content. This might be a product, an experience or listing involvement. Tell bidders what makes it special and why they’ll love it.</p><br />
                                                    <p className='m-0 ps-2'>* Add information about your brand; your values, beliefs and what you stand for - people will bid for love not money when they get what you’re all about.</p>
                                                    <p className='m-0 ps-2'>* Explain the product, service or experience that you are offering </p>
                                                    <p className='m-0 ps-2'>* The more you give, the more you get so be generous in the amount or the value of your offer</p>
                                                    <p className='m-0 ps-2'>* Detail the range of budget you have available and what the paid requirement is (<i>e.g 6 months supply of skincare and between $1,000 - $20,000 for an event attendance - the more they love your brand, the less they’ll need to be paid!</i>)</p>
                                                    <p className='m-0 ps-2'>* Bullet points work well for the offer so you can cover off key points</p>
                                                    <br />
                                                    <h3 class="font-bold">Example description:</h3>
                                                    <br />
                                                    <p className='m-0 ps-2'>DABOO are passionate about engaging young minds and are on a mission to help children thrive as they learn about the world around them. Daboo offers a range of natural world topic, fully sustainable children’s books which are packaged in proven formats to engage in age specific ways. We’re offering:</p>
                                                    <br />
                                                    <p className='m-0 ps-2'>- A set of audio books</p><p>- $5,000 - $10,000 for you and your child to attend our opening immersive experience on the 25th of March, 2023.</p>
                                                </>
                                            )}
                                        </Form>
                                    </Modal.Footer>
                                    </Modal>
                                    <div className="px-lg-4 pt-md-4 mt-4 px-md-0">
                                        <div className="p-4 bg-background shadow rounded-xl">
                                            <div className="d-flex align-items-center justify-content-between mb-4">
                                                <h5 className="mb-0">Offering</h5>
                                                <div>
                                                    <button onClick={() => {setTabID("details")}} className="btn btn-sm btn-outline-primary me-2">Previous</button>
                                                    <button className="btn btn-sm btn-outline-primary me-2" disabled={signupData.offering.length == 0 || !signupData.startDate || !signupData.endDate || (signupData.minimumBudget < 0)} onClick={(event) => {saveCampaign(event,"update")}}>Update</button>
                                                    <button className="btn btn-sm btn-success" disabled={signupData.offering.length == 0 || !signupData.startDate || !signupData.endDate || (signupData.minimumBudget < 0)} onClick={(event) => {saveCampaign(event,"draft")}}>Save as draft</button>
                                                </div>
                                            </div>

                                            <div>
                                                {/* SHOW SELECTED CAMPAIGN TYPE */}
                                                <div className="mb-4">
                                                    <span className="small text-muted">You're creating a <strong className="text-capitalize">{campaignType}</strong> Listing for Members</span>
                                                </div>

                                                
                                                <hr className="mb-4 mt-0" />

                                                <div className="form-group mb-4 position-relative">
                                                    <div className="d-flex align-items-center justify-content-between">
                                                        <label>What we're offering</label>
                                                    </div>
                                                    <span className="small text-muted d-block mb-3">Please include details about the {campaignType} you are offering. People will bid according to how much they love you and want to work with you.</span>

                                                    <GenerativeInput system={offeringPrompt.replace("{brand_name}", brand?.name).replace("{campaign_title}", signupData.name)} disabled={!brand?.features.includes("aiAutoComplete") && !brand?.features.includes("all")}>
                                                        <textarea type="text" rows="6" maxLength="500" className="form-control pe-5" onChange={e => {updateSignupDataState(e); setOfferingCount(e.target.value.length)}} id="offering" value={signupData.offering}></textarea>
                                                        <span className="position-absolute smaller end-0 bottom-0 text-muted me-2 mb-1">{offeringCount}/500</span>  
                                                    </GenerativeInput>
                                                </div>
                                                <hr className="my-4" />
                                                
                                                
                                                {/* BUDGET FIELDS  */}
                                                <Row>
                                                    <Col xs={12} sm={6}>
                                                        <Form.Label>Campaign Currency</Form.Label>
                                                         <span className="small text-muted d-block mb-3">Please include the range of budget available for {campaignType} you are offering.</span>

                                                        <InputGroup className="mb-4">
                                                            <Form.Select className="w-25" id="currency" value={signupData.currency} onChange={event => updateSignupDataState(event)} >
                                                                <option>GBP</option>
                                                                <option>USD</option>
                                                            </Form.Select>
                                                        </InputGroup>  
                                                        
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col xs={12} sm={6}>
                                                        <Form.Label>Min. Budget</Form.Label>
                                                        <InputGroup className="mb-4">
                                                            <Form.Control type="text" id="currency" className="w-25" value={signupData.currency == "GBP" ? "£" : "$"} readOnly />
                                                            <Form.Control type="number" id="minimumBudget" className="w-75" value={signupData.minimumBudget} onChange={event => updateSignupDataState(event)} />
                                                        </InputGroup>  
                                                    </Col>

                                                </Row> 
                                                <hr className="my-4" />

                                                <div className="form-group">
                                                    <label>Listing dates:</label>
                                                    <span className="small text-muted d-block mb-3">This is the period that your listing will be live on the platform for users to bid on. By default, the listing will run for 14 days from the day you publish it unless edited.</span>                

                                                    <Row>
                                                        <div className="col-12 col-md-4 form-group mb-4">
                                                            <label className="text-muted">Start date</label>
                                                            <input type="datetime-local" className="form-control" onChange={updateSignupDataState} defaultValue={campaign && campaign.startDate ? new Date(campaign.startDate*1000).toISOString().slice(0,16) : null} id="startDate"/>
                                                        </div>
                                                        <div className="col-12 col-md-4 form-group mb-4">
                                                            <label className="text-muted">End date</label>
                                                            <input type="datetime-local" className="form-control" onChange={updateSignupDataState} defaultValue={campaign && campaign.endDate ? new Date(campaign.endDate*1000).toISOString().slice(0,16) : null} id="endDate"/>
                                                        </div>
                                                    </Row>
                                                </div>

                                                <hr className="my-4" />

                                                <div className="form-group">
                                                    <label>Contact information required?</label>
                                                    <span className="small text-muted d-block mb-3">Please state any contact information you require from Bidders for delivery tracking </span> 

                                                    <Form.Check inline label="Delivery address" name="contactInfo" type="checkbox" id="deliveryAddress" onChange={updateSignupDataState} defaultChecked={campaign ? campaign.requirements.deliveryAddress : false} />
                                                    <Form.Check inline label="Email address" name="contactInfo" type="checkbox" id="email" onChange={updateSignupDataState} defaultChecked={campaign ? campaign.requirements.email : false} />
                                                    <Form.Check inline label="Phone number" name="contactInfo" type="checkbox" id="phoneNumber" onChange={updateSignupDataState} defaultChecked={campaign ? campaign.requirements.phoneNumber : false} />
                                                </div>
                                                
                                            </div>
                                        </div>
                                    </div>
                                </Tab.Pane>

                            {/* Targeting tab removed and merged into Looking for  */}

                        </Tab.Content>
                    </Col>
                </Row>
            </Container>
        </Tab.Container>
    </>
  );
}

class CreateCampaignView extends Component {
    constructor(props) {
      super(props);
      this.state = {
        error: null,
        isLoaded: false,
        entitlements: [],
        brand: null
      };
      if (props.id){
        this.getCampaign(props.id)
      }
      else{
        this.getEntitlements()
      }
      this.getBrand()
    }
  
    componentDidMount(){
      window.scrollTo(0, 0);
    }

    async getEntitlements() {
        var response = await apiCall("brand/entitlements",{ "method" : "GET" });
        if (response["success"]) {
          this.setState({
            entitlements : response["success"]["entitlements"]
          });
        }
        else {
          this.setState({
            error: response["failure"]["error"]
        });
        }
        this.setState({
          isLoaded: true
        });
      }
  
    async getCampaign(id) {
      var response = await apiCall(`campaign?id=${id}`,{ "method" : "GET" });
      if (response["success"]) {
        this.setState({
          campaign : response["success"]["campaign"]
        });
      }
      else {
        this.setState({
            error: response["failure"]["error"]
      });
      }
      this.setState({
        isLoaded: true
      });
    }

    async getBrand() {
        var response = await apiCall(`brand`,{ "method" : "GET" });
        if (response["success"]) {
          this.setState({
            brand : response["success"]["brand"]
          });
        }
        else {
          this.setState({
              error: response["failure"]["error"]
        });
        }
        this.setState({
          isLoaded: true
        });
      }

    render() {
        const { error, isLoaded, campaign, entitlements, brand } = this.state;
        if (error) {
          return <div className="text-danger text-center h-100 d-flex align-items-center justify-content-start px-4 px-md-0 py-5 flex-column fs-5 bg-secondary"><img src={NoAccess} className="noAccessImg my-5 rounded-xl shadow" /><div>Error: {error}</div></div>;
        } else if (!isLoaded) {
            return <FullPageSpinner />;
        } else {
            if (entitlements.length == 0 && !campaign){
                return (
                    <div className="d-flex align-items-center justify-content-center h-100 w-100">You have no listing entitlements available. Please purchase more or speak with Customer Support to create more listings.</div>
                );
            }
            else if (campaign && campaign.active && this.props.data.sessionType != "impersonation" && this.props.currentProfile.type != "admins" ) {
                return (
                    <p>This is a live listing and so cannot be modified. Please speak with Customer Support if you need to make changes to this listing after it has been published.</p>
                );
            }
            else {
                return (
                    <>
                    {campaign ? <CreateCampaignFunction campaign={campaign} cloneCampaign={this.props.cloneCampaign} brand={brand} /> : <CreateCampaignFunction brand={brand} /> }
                    </>
                );
            }
        }
    }
}

export default function CreateCampaign() {
    let [searchParams] = useSearchParams();
    var campaignID = null;
    var cloneCampaign = false;
    const navigate = useNavigate()
    const { data, currentProfile } = useAuthContext();

    if (searchParams.get('id')) {
        campaignID = searchParams.get('id');
    }
    else {
        if (searchParams.get('cloneTargetID')) {
            campaignID = searchParams.get('cloneTargetID')
            cloneCampaign = true
        }
    }
  
    return (
      <div className="createCampaign">
        <Topbar/>
        <div className="pageName">My Listings</div>
        <Container className="fullscreenWithTopBar px-0" fluid>
                <CreateCampaignView id={campaignID} cloneCampaign={cloneCampaign} navigate={navigate} data={data} currentProfile={currentProfile} />
        </Container>
        <Footer />
      </div>
    );
}